import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Adresse} from '../../../class/api/Adresse';
import {HydraService} from '../../../core/services/hydra.service';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {Country} from "../../../interface/api/Country";
import {Departement} from "../../../interface/api/Departement";
import { ControlsMessagesComponent } from '../controls-messages/controls-messages.component';
import { MatSelect } from '@angular/material/select';

import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-geocoder-lab',
    template: `
        <form class="form-horizontal" [formGroup]="formGroup">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="numEtVoie"
                  >Numéro et rue : <span class="star">*</span></label
                  >
                  <input
                    class="form-control"
                    id="numEtVoie"
                    type="text"
                    [formControl]="numEtVoieCtrl"
                    />
                    <app-controls-messages
                      [control]="numEtVoieCtrl"
                    ></app-controls-messages>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="numEtVoie"
                      >Code postal : <span class="star">*</span></label
                      >
                      <input
                        class="form-control"
                        id="codePostal"
                        type="text"
                        [formControl]="codePostalCtrl"
                        />
                        <app-controls-messages
                          [control]="codePostalCtrl"
                        ></app-controls-messages>
                      </div>
                    </div>
                    <div class="col">
                      <label for="numEtVoie"
                        >Ville : <span class="star">*</span></label
                        >
                        <input
                          class="form-control"
                          id="ville"
                          type="text"
                          [formControl]="villeCtrl"
                          />
                          <app-controls-messages
                            [control]="villeCtrl"
                          ></app-controls-messages>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <label for="numEtVoie">Cedex : </label>
                            <input
                              class="form-control"
                              id="cedex"
                              type="text"
                              [formControl]="cedexCtrl"
                              />
                              <app-controls-messages
                                [control]="cedexCtrl"
                              ></app-controls-messages>
                            </div>
                          </div>
                          <div class="col">
                            <label for="numEtVoie"
                              >Pays : <span class="star">*</span></label
                              >
                              <mat-select
                                class="form-control"
                                id="country"
                                [formControl]="paysCtrl"
                                [compareWith]="compareById"
                                id="locale"
                                required
                                >
                                @for (country of countries; track country) {
                                  <mat-option
                                    [value]="country['@id']"
                                    >{{ country?.label }}</mat-option
                                    >
                                }
                              </mat-select>
                              <app-controls-messages
                                [control]="paysCtrl"
                              ></app-controls-messages>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <div class="form-group">
                                <label for="numEtVoie">Departement : </label>
                                <input
                                  class="form-control"
                                  id="departement"
                                  type="text"
                                  [formControl]="departementCtrl"
                                  />
                                  <app-controls-messages
                                    [control]="departementCtrl"
                                  ></app-controls-messages>
                                </div>
                              </div>
                              <div class="col">
                                <div class="form-group">
                                  <label for="numEtVoie">Région : </label>
                                  <input
                                    class="form-control"
                                    id="region"
                                    type="text"
                                    [formControl]="regionCtrl"
                                    />
                                    <app-controls-messages
                                      [control]="regionCtrl"
                                    ></app-controls-messages>
                                  </div>
                                </div>
                              </div>
                            </form>
        `,
    imports: [FormsModule, ReactiveFormsModule, ControlsMessagesComponent, MatSelect, MatOption]
})
export class GeocoderLabComponent implements OnInit, AfterViewInit {
    private hydraService = inject(HydraService);

    // id?:number;
    // adresseComplete?:string = null;
    // numEtVoie?:string = null;
    // codePostal?:string = null;
    // ville?:string = null;
    // // Country, sous forme d'IRI ou d'objet
    // pays?:any = null;
    // lat?:number = null;
    // lon?:number = null;
    @Input() public adresse?: Adresse = null;
    @Output() place: EventEmitter<Adresse> = new EventEmitter();
    @Input() disabled = false;
    z;

    public formGroup: FormGroup;

    public numEtVoieCtrl: FormControl<string> = new FormControl<string>('', [
        Validators.required,
        Validators.minLength(2),
    ]);
    public codePostalCtrl: FormControl<string> = new FormControl<string>('', [
        Validators.required,
        Validators.pattern('^[0-9]{5,5}$'),
    ]);
    public villeCtrl: FormControl<string> = new FormControl<string>('', [
        Validators.required,
        Validators.minLength(2),
    ]);
    public paysCtrl: FormControl<string|Country> = new FormControl<string|Country>('', [Validators.required]);
    public cedexCtrl: FormControl<string> = new FormControl<string>('');
    public departementCtrl: FormControl<string|Departement> = new FormControl<string|Departement>('');
    public regionCtrl: FormControl<string> = new FormControl<string>('');

    constructor() {
        this.formGroup = new FormGroup({
            numEtVoie: this.numEtVoieCtrl,
            codePostal: this.codePostalCtrl,
            ville: this.villeCtrl,
            pays: this.paysCtrl,
            cedex: this.cedexCtrl,
            departement: this.departementCtrl,
            region: this.regionCtrl,
        });
    }

    ngAfterViewInit() {
        if (this.adresse != null) {
            this.numEtVoieCtrl.setValue(this.adresse.numEtVoie);
            this.numEtVoieCtrl.markAsTouched();
            this.codePostalCtrl.setValue(this.adresse.codePostal);
            this.codePostalCtrl.markAsTouched();
            this.villeCtrl.setValue(this.adresse.ville);
            this.villeCtrl.markAsTouched();
            this.paysCtrl.setValue(this.adresse.pays['@id']);
            this.paysCtrl.markAsTouched();
            this.cedexCtrl.setValue(this.adresse.cedex);
            this.cedexCtrl.markAsTouched();
            this.departementCtrl.setValue(this.adresse['departement']);
            this.departementCtrl.markAsTouched();
            this.regionCtrl.setValue(this.adresse['region']);
            this.regionCtrl.markAsTouched();
        }
        if (this.disabled) {
            this.numEtVoieCtrl.disable();
            this.codePostalCtrl.disable();
            this.villeCtrl.disable();
            this.paysCtrl.disable();
            this.cedexCtrl.disable();
            this.departementCtrl.disable();
            this.regionCtrl.disable();
        }
    }

    public compareById(itemOne, itemTwo) {
        return itemOne && itemTwo && itemOne == itemTwo;
    }
    public countries = [];
    ngOnInit() {
        this.hydraService
            .getList(api.countries, true)
            .subscribe((res: HydraCollection) => {
                this.countries = res.getMember();
            });
        //Si la valeur du form est valid alors on déclanche l'émetteur a chaque changement
        this.formGroup.valueChanges.subscribe(res => {
            if (this.formGroup.valid) {
                this.adresse = this.formGroup.getRawValue() as Adresse;
                this.place.emit(this.adresse);
            }
        });
    }
}
